var map = {
	"./cookies.svg": "4a01",
	"./icon-3d_print.svg": "16f2",
	"./icon-3d_scan.svg": "5f4c",
	"./icon-access.svg": "3cd3",
	"./icon-adress.svg": "3afc",
	"./icon-app.svg": "a2d5",
	"./icon-clients.svg": "fae0",
	"./icon-cloud.svg": "4b00",
	"./icon-destroy.svg": "352b",
	"./icon-docs.svg": "e565",
	"./icon-docs2.svg": "5622",
	"./icon-email.svg": "477a",
	"./icon-format.svg": "3555",
	"./icon-innovation.svg": "3cd4",
	"./icon-phone.svg": "3ff5",
	"./icon-stats.svg": "373e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";